import { pathjoin } from '@gandi/utils';
const itemProductTypeToAppName = {
  certificates: 'certificate',
  domain_option: 'domain',
  domains: 'domain',
  iaas: 'cloud',
  'mailbox-standalone': 'mail',
  mailbox: 'domains',
  mailboxv2: 'domain',
  paas: 'simplehosting',
  services: 'services',
  sites: 'domains',
  tmch: 'organizations'
};
export function getLink({
  adminURL,
  sharingId,
  item,
  orderId,
  productType: defaultProductType
}) {
  const productType = item?.product_type || defaultProductType;
  if (productType === 'mailbox-standalone') return pathjoin(adminURL, `mail/${sharingId}/dashboard?order_id=${orderId}`);
  if (productType === 'mailboxv2' && item?.details?.domain) return pathjoin(adminURL, `domain/${sharingId}/${item.details.domain}/mail/mailboxes`);
  if (productType === 'paas' && !!item?.details?.product_uuid) return pathjoin(adminURL, `simplehosting/${sharingId}/instances/${item.details.product_uuid}/welcome/configuration`);
  if (productType === 'domain_option' && item?.name === 'premium_dns' && !!item.details?.fqdn) return pathjoin(adminURL, `domain/${sharingId}/${item.details.fqdn}/nameservers`);
  if (productType === 'domains' && item?.name) return pathjoin(adminURL, `domain/${sharingId}/${item.name}/overview`);
  const appName = productType && itemProductTypeToAppName[productType] || 'dashboard';
  return pathjoin(adminURL, appName, sharingId);
}